export enum ModuleTypes {
  FormWithBackground = 'FormWithBackground',
  NearbyLocations = 'NearbyLocations',
  ProductCardList = 'ProductCardList',
  ItemList = 'ItemList',
  FinePrint = 'FinePrint',
  HeroWithRightImage = 'HeroWithRightImage',
  SocialReviewCards = 'SocialReviewCards',
  BasicCardList = 'BasicCardList',
  ImageLeftTextRightModule = 'ImageLeftTextRightModule',
  DataTable = 'DataTable',
  HeroResource = 'HeroResource',
  BlogPosts = 'BlogPosts',
  LinkCardList = 'LinkCardList',
  Quote = 'Quote',
  CardList = 'CardList',
  SimpleHero = 'SimpleHero',
  QnAs = 'QnAs',
  PrincipalCustomers = 'PrincipalCustomers',
  LinkList = 'LinkList',
}
